import installTCFMutationObserver from './installTCFMutationObserver'

export default installTCFMutationObserver
